// Sumar creaciones a un lanzamiento DESDE su ficha — el camino que faltaba.
//
// La ficha vacía decía "Buscá una imagen generada y tocá Enviar a lanzamiento" y nada
// más: mandaba a otra pantalla sin un botón para ir. Caso real 2026-09-14 (47 Street):
// dos lanzamientos creados, la persona entró a cada ficha, se fue a los 10-20 segundos y
// nunca les puso una foto (ADR-2026-09-17-la-ficha-vacia-del-lanzamiento-elige-creaciones).
//
// La regla de a qué producto va cada creación es la MISMA que la del botón "Enviar a
// lanzamiento" (`EnviarALanzamiento`): la que se generó con un producto va a ese producto;
// la que no (asistente libre, creativo plus) se le pregunta contra el catálogo. Acá vive la
// parte pura —repartir— para que se pueda probar sin pantalla; el selector de catálogo se
// reusa tal cual del botón.

import type { GeneradaParaElegir, ItemAEnviar } from './lanzamientosApi';

export interface Reparto {
  /** Van derecho: se sabe el producto. */
  conProducto: ItemAEnviar[];
  /** Hay que preguntar a qué producto. */
  sinProducto: GeneradaParaElegir[];
}

/** Separa lo que se puede mandar solo de lo que necesita que la persona elija producto. */
export function repartirPorProducto(
  elegidas: readonly GeneradaParaElegir[],
  productoDeVariante: ReadonlyMap<string, string>,
): Reparto {
  const conProducto: ItemAEnviar[] = [];
  const sinProducto: GeneradaParaElegir[] = [];
  for (const img of elegidas) {
    const productoId = img.varianteId ? productoDeVariante.get(img.varianteId) : undefined;
    if (productoId) conProducto.push({ imagenGeneradaId: img.id, productoId, varianteId: img.varianteId });
    else sinProducto.push(img);
  }
  return { conProducto, sinProducto };
}

/** Todas al mismo producto: lo que eligió la persona en el catálogo. */
export function itemsParaProducto(imagenes: readonly GeneradaParaElegir[], productoId: string): ItemAEnviar[] {
  return imagenes.map((img) => ({ imagenGeneradaId: img.id, productoId, varianteId: img.varianteId }));
}

/** El aviso de la ficha después de sumar. */
export function avisoDeSuma(agregadas: number, yaEstaban: number): string {
  if (agregadas === 0) return yaEstaban > 0 ? 'Ya estaban en el lanzamiento.' : 'No se sumó ninguna creación.';
  const sumadas = agregadas === 1 ? '1 creación sumada' : `${agregadas} creaciones sumadas`;
  return yaEstaban > 0 ? `${sumadas}; ${yaEstaban} ya estaba${yaEstaban === 1 ? '' : 'n'}.` : `${sumadas}.`;
}
